// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".markdown[data-v-199f273e] P{line-height:1.25;margin-bottom:10px}.markdown[data-v-199f273e] LI:not(:last-child){margin-bottom:10px}.markdown[data-v-199f273e] code{font-size:12.5px;line-height:normal;padding:0}", ""]);
// Exports
module.exports = exports;
